import { OrderOperations } from "./OrderOperations"
import {
  OrderModificationShippingFees,
  OrderModificationType,
  ShippingFeeModificationUpdateData
} from "lib/types/generated/graphql-types"

export class ModificationShippingFees extends OrderOperations {
  constructor(modification: OrderModificationShippingFees[]) {
    super(
      modification?.filter(
        (modification) => modification?.type === OrderModificationType?.ShippingFees
      )
    )
  }

  public pendingModifications(): OrderModificationShippingFees[] {
    return this.pendingList() as OrderModificationShippingFees[]
  }

  public failedModifications(): OrderModificationShippingFees[] {
    return this.failedList() as OrderModificationShippingFees[]
  }

  public getPendingModification(): OrderModificationShippingFees {
    const pendingList = this.pendingList() as OrderModificationShippingFees[]
    return pendingList[0]
  }

  public getOngoingModification(): OrderModificationShippingFees {
    const ongoingList = this.ongoingList() as OrderModificationShippingFees[]
    return ongoingList[0]
  }

  public updateOutputToInput(
    data: ShippingFeeModificationUpdateData
  ): ShippingFeeModificationUpdateData {
    return {
      id: data.id,
      taxGroupId: data.taxGroupId,
      price: {
        basePriceAmount: data?.price?.basePriceAmount ?? 0,
        salePriceAmount: data?.price?.salePriceAmount,
        taxPercentage: data?.price?.taxPercentage ?? 0
      }
    }
  }
}
